(function ($, Cobalt, undefined) {
    Cobalt.Listing = {

        processRowClick: function (e) {

            var source = e.target;
            var parent = $(source).parent();
            var row = $(this);

            // If an input element exists inside the clicked element,
            if (source != null) {
                var ignoredTags = ["INPUT", "TEXTAREA", "A", "BUTTON"];
                if ($.inArray(source.tagName, ignoredTags) > -1) {
                    return;
                }
                if (parent != null && $.inArray(parent[0].tagName, ignoredTags) > -1) {
                    return;
                }
                if ($(source).find("input").length > 0 || $(source).find("form").length > 0) {
                    return;
                }
            }

            // Look for the first hyperlink with the class 'title'
            var href = $(this).find('a.title');

            if (href.length == 0) {
                href = $(this).find('.title a');
            }

            // If it cannot be found, just use the first hyperlink
            if (href.length == 0) {
                href = $(this).find('a:first');
            }

            if (href.length >= 1) {
                e.preventDefault();
                document.location = href.attr('href');
            }
        },
        processPagination: function () {


            // Fix filters
            var $listings = $(".listing-container");
            $listings.each(function () {
                var viewState = $(this).find("[data-viewstate]").attr("data-viewstate");
                if (viewState == "" || viewState == undefined) {
                    return;
                }
                var $filters = $(this).find("form.listing-filters");
                $filters.each(function () {
                    var action = $(this).attr("action");
                    if (action.indexOf("#") == -1) {
                        $(this).attr("action", action + viewState);
                    }
                });
            });

            // Make each link in the paging list use the current view state (hash tags)
            var $pagingList = $(".paging-list");
            $pagingList.each(function () {
                var viewState = $pagingList.attr("data-viewstate");
                if (viewState == "" || viewState == undefined) {
                    return;
                }
                var $pagination = $pagingList.find("> li > a");
                $pagination.each(function () {
                    var href = $(this).attr("href");
                    if (href.indexOf("#") == -1) {
                        $(this).attr("href", href + viewState);
                    }


                });
            });


            // Make each sort link in the paging list use the current view state (hash tags)
            var $tableList = $("table.listing");
            $tableList.each(function () {
                var viewState = $(this).attr("data-viewstate");
                if (viewState == "" || viewState == undefined) {
                    return;
                }
                var $columnLinks = $(this).find("> thead > tr > th > a");

                $columnLinks.each(function () {
                    var href = $(this).attr("href");
                    if (href.indexOf("#") == -1) {
                        $(this).attr("href", href + viewState);
                    }
                });
            });
        },
        initialize: function () {
            Cobalt.Listing.CurrentListingUrl = encodeURIComponent(self.location.pathname);
            Cobalt.runOnHtmlInsert(Cobalt.Listing.process);
            Cobalt.Listing.bindAjaxScrolling();
            
        },
        bindAjaxScrolling: function () {
            var $ajaxListings = $(".listing[data-ajax-url]");

            $ajaxListings.each(function (i, elem) {
                var listing = $(elem);
                var listingContainer = listing.parents(".listing-container");
                var scrollingEnabled = listing.data("scroll-inline") === "True";

                if (scrollingEnabled) {
                    var timer;
                    $(document).on("scroll.get-next-page", function () {
                        // executing the getNextPage function inside of a setTimeout serves to prevent
                        // getting the same page several times per scroll.
                        clearTimeout(timer);

                        timer = setTimeout(function() {
                            var lastItemsDistanceFromTop = listing.children("li")
                                                                  .last()[0]
                                                                  .getBoundingClientRect()
                                                                  .top;

                            var href = listingContainer.find("a[data-next-page]").attr("href");
                            var moreItemsToFetch = href != undefined;

                            if (lastItemsDistanceFromTop < 1000 && moreItemsToFetch) {
                                Cobalt.Listing.getNextPage(href, listing.attr("data-ajax-url"), listing, listingContainer);
                            } else if(!moreItemsToFetch) {
                                $(document).off("scroll.get-next-page");
                            }
                        }, 100);
                    });
                }
            });
            
        },
        processAjax: function () {
            // Setup AJAX
            var $ajaxListings = $(".listing[data-ajax-url]");
            $ajaxListings.each(function (i, elem) {

                var $listing = $(elem);
                var $listingContainer = $listing.parents(".listing-container");

                if ($listingContainer.data("ajax-paging-initialized")) {
                    return;
                }
                $listingContainer.data("ajax-paging-initialized", true);

                // Wire up paging and sorting
                $listingContainer.find(".j-listing-pagination,.j-listing-table-header").on("click", "a", function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    var href = $(this).attr("href"); // Get the href of the page or sort link                    
                    var ajaxLoadUrl = $listing.attr("data-ajax-url"); // get the ajax url.

                    Cobalt.Listing.getNextPage(href, ajaxLoadUrl, $listing, $listingContainer);
                });

            });
        },
        getNextPage: function(href, ajaxLoadUrl, $listing, $listingContainer) {
            var ajaxSetWindowState = $listing.attr("data-ajax-set-window-state");
            var scrollIn = $listing.data("page-inline") === "True";

            var linkQuery = new Cobalt.QueryParser(href);
            var ajaxQuery = new Cobalt.QueryParser(ajaxLoadUrl);

            linkQuery.mergeFrom(ajaxQuery.keyValuePairs);

            // Remove any parameters from the ajax load url
            if (ajaxLoadUrl.indexOf("?") > 0) {
                ajaxLoadUrl = ajaxLoadUrl.substring(0, ajaxLoadUrl.indexOf("?"));
            }

            // Use the merged query parameters
            ajaxLoadUrl = ajaxLoadUrl + linkQuery.toString();


            // Setup the push state url
            var pushStateUrl = href;
            if (href.indexOf("#") < 0) {
                pushStateUrl = pushStateUrl + self.location.hash;
            }

            // Mask the listing, to indicate loading
            $listingContainer.mask();

            // Make the ajax request
            $.ajax(
            {
                url: ajaxLoadUrl,
                cache: false,
                headers:
                {
                    "x-cobalt-listing-url": Cobalt.Listing.CurrentListingUrl
                },
                error: function (xhr, status, errorThrown) {
                    $listingContainer.unmask();
                    return false;
                },
                success: function (data) {
                    if (ajaxSetWindowState === "true") {
                        if (window.history.replaceState != null) {
                            window.history.replaceState(null, "", pushStateUrl);
                        }
                    }

                    $listingContainer.unmask();

                    // Insert the new listing in place of the old one
                    var newListing = $(data);

                    var oldListing = $listing.parents(".listing-container");
                    var listingParent = oldListing.parent();
		    var preventAjaxScroll = newListing.find('.listing').attr("data-prevent-ajax-scroll");
                    if (!preventAjaxScroll) {
	                    if (!scrollIn) {
	                        oldListing.remove();
	                        listingParent.append(newListing);

	                        // Scroll the listing header (which has pagination) back into view.
	                        var docScrollTop = (document.documentElement.scrollTop || document.body.scrollTop);
	                        var useListingHeader = newListing.find(".listing-header").length > 0 && newListing.find(".listing-header").is(":visible");
	                        var listingScrollTop = (useListingHeader ? newListing.find(".listing-header") : newListing).offset().top - 20;
	                        var wh = (window.innerHeight && window.innerHeight < $(window).height()) ? window.innerHeight : $(window).height();
	                        var isAlreadyVisible = listingScrollTop > docScrollTop;
	                        if (!isAlreadyVisible) {
	                            $("body,html,document").animate({ scrollTop: listingScrollTop }, 1000);
	                        }
	                    } else {

	                        var footer = newListing.find('.listing-footer');
	                        newListing = newListing.find('.listing-body >ul').children();
	                        listingParent.find('.listing').append(newListing);

	                        if (footer.find('a[data-next-page]').length > 0) {
	                            oldListing.find('.listing-footer').find('a').attr('href', footer.find('a[data-next-page]').attr('href'));
	                        } else {
	                            oldListing.find('.listing-footer').remove();
	                        }

	                    }
		    }

                    Cobalt.triggerHtmlInsert(listingParent);


                    // Google Analytics support
                    if (window._gaq) {
                        _gaq.push(['_trackPageview']);
                    }

                    return true;
                }
            });

            return false;
        },
        process: function () {
            $('table.listing-auto-link > tbody > tr').click(Cobalt.Listing.processRowClick);
            $('ul.listing-auto-link > li').click(Cobalt.Listing.processRowClick);
            Cobalt.Listing.processAjax();
            Cobalt.Listing.processPagination();
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Listing.js